export const PrivateLoungeActionTypes = {
    FETCH_PRIVATE_LOUNGE_REQUEST:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGE_REQUEST",
    FETCH_PRIVATE_LOUNGE_SUCCESS:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGE_SUCCESS",
    FETCH_PRIVATE_LOUNGE_FAILURE:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGE_FAILURE",

    FETCH_PRIVATE_LOUNGES_REQUEST:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGES_REQUEST",
    FETCH_PRIVATE_LOUNGES_SUCCESS:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGES_SUCCESS",
    FETCH_PRIVATE_LOUNGES_FAILURE:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGES_FAILURE",

    UPDATE_PRIVATE_LOUNGE_REQUEST:
        "@@PrivateLounge/UPDATE_PRIVATE_LOUNGE_REQUEST",
    UPDATE_PRIVATE_LOUNGE_SUCCESS:
        "@@PrivateLounge/UPDATE_PRIVATE_LOUNGE_SUCCESS",
    UPDATE_PRIVATE_LOUNGE_FAILURE:
        "@@PrivateLounge/UPDATE_PRIVATE_LOUNGE_FAILURE",

    FETCH_PRIVATE_LOUNGE_USER_REQUEST:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGE_USER_REQUEST",
    FETCH_PRIVATE_LOUNGE_USER_SUCCESS:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGE_USER_SUCCESS",
    FETCH_PRIVATE_LOUNGE_USER_FAILURE:
        "@@PrivateLounge/FETCH_PRIVATE_LOUNGE_USER_FAILURE",
};
